import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Table, Container, Card, Modal } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { AiFillDelete } from 'react-icons/ai';
import { AiFillEdit } from 'react-icons/ai';
import { FcViewDetails } from 'react-icons/fc';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import editIcon from '../../assets/images/icons/icon-edit.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import Pagination from 'react-bootstrap/Pagination';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import moment from 'moment';
import _ from 'lodash';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';

const RedeemRewardPoints = () => {
    const [redeemRewardPoints, setRedeemRewardPoints] = useState();
    const [activeNumber, setActiveNumber] = useState(1);
    const [selectedItem, setSelectedItem] = useState();
    const [showDelModal, setShowDelModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(false);
    const [paginationBtns, setPaginationBtns] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [isTypeFilterSelected, setIsTypeFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [conversionTiers, setConversionTiers] = useState([]);
    const navigate = useNavigate();
    const { getToken, user } = useAuth();

    useEffect(() => {
        getAllRedeemPoints(pageSize);
        fetchConversionTiers();
    }, []);

    const handleClose = () => {
        setShowDelModal(false);
        setShowEditModal(false);
        setShowDetailModal(false);
    };

    const getAllRedeemPoints = async (pageSize = 10, pageNo = 1, _search) => {
        const authToken = getToken();

        if (authToken) {
            setLoading(true);
            let allAwardedPoints = await new WebApiCalls().getAllRedeemPoints(authToken, pageSize, pageNo, _search);
            setRedeemRewardPoints(allAwardedPoints?.data?.redeemList);
            setTotalRecords(allAwardedPoints?.data?.totalRecords);
            setLoading(false);
        }
    };

    const fetchConversionTiers = async () => {
        const token = getToken();
        const tiers = await new WebApiCalls().getConversionTiers(token);
        setConversionTiers(tiers?.data || []);
    };

    const handleDelete = async () => {
        const token = getToken();
        if (token && selectedItem?._id) {
            new WebApiCalls()
                .deleteRedeemRewards(token, { userId: selectedItem?._id, rewardId: selectedItem?.reward?._id })
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Redeemed reward has been deleted successfully.');
                        getAllRedeemPoints();
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Commuter Name</span>
                </h6>
            ),
            selector: (row) => row?.name || '',
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Reward Title</span>
                </h6>
            ),
            selector: (row) => row.reward?.name,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Points Spent</span>
                </h6>
            ),
            selector: (row) => row?.reward?.requiredPoints,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Time stamp</span>
                </h6>
            ),
            selector: (item) => (item?.reward?.updatedAt ? moment(item?.reward?.updatedAt).format('MM-DD-YYYY, h:mm a') : ''),
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <img
                            width={15}
                            className="me-3"
                            src={viewIcon}
                            alt=""
                            onClick={() => {
                                navigate('/redeemed-rewards/redeemed-reward-details', { state: { data: row } });
                            }}
                        />
                    </div>
                    <div className="del-detail">
                        <img
                            width={15}
                            src={delIcon}
                            alt=""
                            onClick={() => {
                                setSelectedItem(row);
                                setShowDelModal(true);
                            }}
                        />
                    </div>
                </div>
            ),
            center: true
        }
    ];

    const customStyles = {
        rows: {
            style: {
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
    };

    const handlePageChange = (pageNo) => {
        getAllRedeemPoints(pageSize, pageNo);
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllRedeemPoints(pageSize, pageNo);
        setPageSize(pageSize);
        setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text) => {
        getAllRedeemPoints(undefined, undefined, text);
    }, 2000);

    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkAwardedPoints(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllRedeemPoints();
                            setLoading(false);
                            toast.success('Awarded Points are Delete Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                        }}
                    />
                </Col>
                <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                    <div className="d-flex gap-10 justify-content-start">
                        <h6 className="text-capitalize mt-2 text-center"></h6>
                    </div>
                </Col>
                <Col sm={5} md={5}>
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        deleteBulk();
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                    </div>
                </Col>
            </Row>
            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Redeem Reward?'} />
            <DataTable
                columns={columns}
                data={redeemRewardPoints}
                selectableRows
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={redeemRewardPoints && redeemRewardPoints?.length >= 0 ? false : true}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
            />
            {user?.role !== 'vendor' && (
                <div>
                    <h3>Redeem Your Points</h3>
                    <ul>
                        {conversionTiers.map((tier) => (
                            <li key={tier.points}>
                                {tier.points} points = ${tier.cashValue}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default RedeemRewardPoints;
